export enum NotificationTypesEnum {
        Text = 2126,
        CallCell = 2127,
        CallHome = 2128,
}
